import { render, staticRenderFns } from "./LicenseCheck.vue?vue&type=template&id=4878fa8e&scoped=true"
import script from "./LicenseCheck.vue?vue&type=script&lang=js"
export * from "./LicenseCheck.vue?vue&type=script&lang=js"
import style0 from "./LicenseCheck.vue?vue&type=style&index=0&id=4878fa8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4878fa8e",
  null
  
)

export default component.exports